import CCColors, {updateColorWithOpacity} from '@/Utils/CCColors';
import {StyleSheet} from 'react-native';

export const styles = StyleSheet.create({
  container: {flexDirection: 'row'},
  left: {flex: 0.2, padding: 20},
  center: {flex: 0.5},
  right: {flex: 0.3, padding: 10},
  scrollContainer: {
    flex: 1,
    backgroundColor: '#FFFFFF',
  },
  addNewBox: {
    backgroundColor: '#FACF47',
    padding: 10,
    borderRadius: 20,
    alignItems: 'center',
    justifyContent: 'center',
  },
  participantsName: {
    paddingVertical: 10,
    paddingHorizontal: 12,
    marginHorizontal: 10,
    marginVertical: 4,
    borderRadius: 12,
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    borderWidth: 1.5,
    borderColor: '#F4EFE6',
    backgroundColor: '#FFFFFF',
    shadowColor: '#000000',
    shadowOffset: {width: 0, height: 2},
    shadowOpacity: 0.015,
    shadowRadius: 4,
    elevation: 1,
    transitionProperty: 'all',
    transitionDuration: '0.2s',
    transitionTimingFunction: 'ease-in-out',
  },
  hoveredName: {
    backgroundColor: '#FFFDF6',
    borderColor: '#EAE2D5',
  },
  selectedName: {
    backgroundColor: '#FFFDF6',
    borderColor: '#FACF47',
    borderLeftWidth: 3,
    borderLeftColor: '#FACF47',
    shadowColor: '#FACF47',
    shadowOffset: {width: 0, height: 2},
    shadowOpacity: 0.08,
    shadowRadius: 6,
    elevation: 2,
  },
  rowLeading: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 10,
    flex: 1,
    marginRight: 8,
  },
  avatarCircle: {
    width: 26,
    height: 26,
    borderRadius: 13,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#FFFFFF',
    borderWidth: 1.5,
  },
  avatarCircleYou: {
    backgroundColor: '#2C1A11',
    borderColor: '#2C1A11',
  },
  avatarText: {
    fontSize: 11,
    fontWeight: '700',
  },
  avatarTextYou: {
    color: '#FACF47',
  },
  roleBadge: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 3,
    backgroundColor: '#FAF6EB',
    paddingHorizontal: 6,
    paddingVertical: 2,
    borderRadius: 4,
    borderWidth: 0.5,
    borderColor: '#EAE2D5',
  },
  ownerBadge: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 3,
    backgroundColor: 'rgba(165,121,47,0.15)',
    paddingHorizontal: 6,
    paddingVertical: 2,
    borderRadius: 4,
    borderWidth: 0.5,
    borderColor: 'rgba(165,121,47,0.4)',
  },
  contributorBadge: {
    backgroundColor: 'rgba(250,207,71,0.12)',
    borderColor: 'rgba(165,121,47,0.25)',
  },
  viewerBadge: {
    backgroundColor: '#FAF6EB',
    borderColor: '#EAE2D5',
  },
  roleToggleContainer: {
    flexDirection: 'row',
    borderRadius: 6,
    overflow: 'hidden',
    borderWidth: 1,
    borderColor: '#EAE2D5',
  },
  roleTogglePill: {
    paddingHorizontal: 8,
    paddingVertical: 3,
  },
  roleTogglePillActive: {
    backgroundColor: '#FACF47',
  },
  actionButton: {
    width: 26,
    height: 26,
    borderRadius: 7,
    alignItems: 'center',
    justifyContent: 'center',
    transitionProperty: 'background-color',
    transitionDuration: '0.15s',
  },
});
